import { render, staticRenderFns } from "./manageRule.vue?vue&type=template&id=eabad12a&scoped=true"
import script from "./manageRule.vue?vue&type=script&lang=js"
export * from "./manageRule.vue?vue&type=script&lang=js"
import style0 from "./manageRule.vue?vue&type=style&index=0&id=eabad12a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eabad12a",
  null
  
)

export default component.exports